import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import AuthService from "../services/auth.service";
import { useNavigate } from "react-router-dom";
import Helpers from "../services/helpers";
import { AppDispatch, RootState } from "../app/store";
import { useDispatch, useSelector } from "react-redux";
import { fetchWallet } from "../app/slice/walletSlice";
import { showToast } from "../app/slice/toastsSlice";


function CalculatorModel(props: any) {
    const [showedit, setShowedit] = useState(false);
    const handleCloseedit = () => setShowedit(false);
    const cancelCalculator = () => props?.setCalculatorVisible(false);
    const [betData, setBetData] = useState(props?.betData);
    const [betAmount, setBetAmount] = useState<any | Number>('');
    const [message, setMessage] = useState("");
    const [loading, setLoading] = useState(false);
    const [isBetAllow, setIsBetAllow] = useState(false);    
    const [betProfitLoss, setBetProfitLoss] = useState<any | Number>(0);
    const dispatch = useDispatch<AppDispatch>();
    const [wallet, setWallet] = useState<any | Number>(useSelector((state: RootState) => state.wallet.wallet));
    const navigate = useNavigate();
    let toast = {
        type: '',
        title: '',
        message: ''
    }

    useEffect(() => {
        setBetData(props?.betData);  
        // eslint-disable-next-line
    }, [props]);

    useEffect(() => {
        setShowProfitLossValue();
        //if (betData?.bet_type) {
            //betValidation();
        //}
        // eslint-disable-next-line
    }, [betAmount, betData?.price]);

    function setShowProfitLossValue() {
        let profitLoss = 0;
        // console.log(betData)
        if (betData?.selection_type === 'lay') {
            if (betData?.bet_type === 'odds' || betData?.bet_type === 'fancy_1' || betData?.bet_type === 'odd_even') {
                profitLoss = ((betData?.price) * betAmount) - betAmount;
                setBetProfitLoss(profitLoss.toFixed(2));
            } else {
                let rate = betData?.bet_type === 'bookmakers' || betData?.bet_type === 'tied_match' ? betData?.price : betData?.size;
                profitLoss = (rate / 100) * betAmount;
                setBetProfitLoss(profitLoss.toFixed(2));
            }
        }
        if (betData?.selection_type === 'back') {
            profitLoss = Number(betAmount);
            if (betData?.bet_type === 'odds' || betData?.bet_type === 'fancy_1' || betData?.bet_type === 'odd_even') {
                setBetProfitLoss((((betData?.price) * betAmount) - betAmount).toFixed(2));
            } else {
                let rate = betData?.bet_type === 'bookmakers' || betData?.bet_type === 'tied_match' ? betData?.price : betData?.size;
                setBetProfitLoss(((rate / 100) * betAmount).toFixed(2));
            }

        }
        if (betData?.selection_type === 'odd' || betData?.selection_type === 'even') {
            setBetProfitLoss((((betData?.price) * betAmount) - betAmount).toFixed(2));
        }

        setBetData({
            ...betData,
            ['actual_amount']: betAmount,
            ['bet_amount']: profitLoss,
            ['payout_amount']: Number(betAmount) + Number(profitLoss),
        });
    }

    const handleAmountAdd = (event: any, amt: number) => {
        event.preventDefault();
        setMessage('');
        setBetAmount(Number(betAmount) + amt);
    };

    const handleStakeClick = (amt: number) => {
        setMessage('');
        setBetAmount(amt);
    };

    const handleClearAmount = () => {
        setMessage('');
        setBetAmount(0);
        //betValidation();
    };

    const onChangeAmount = (e: any) => {
        setMessage('');
        let amount = Number(e.target.value);
        if (!isNaN(amount)) {
            setBetAmount(amount);
        }
    };

    function betValidation() {
        // console.log(betAmount)
        if (betAmount === '') {
            return;
        }
        let fData = {
            amount: betAmount,
            wallet: wallet?.user_combined_wallet,
            type: betData?.bet_type,
            min: betData?.min,
            max: betData?.max
        }

        let res = Helpers.betValidation(fData);
      
        if (!res?.status) {
            setIsBetAllow(false);
            setMessage(res?.message);
            return;
        }
        setIsBetAllow(true);
        return;
    }

    function handlePlaceBet() {
        // if (!isBetAllow) return;
        // setBetData({
        //     ...betData,
        //     ['actual_amount']: betAmount,
        //     ['bet_amount']: betProfitLoss,
        // });
        setMessage('');
        setLoading(true);
        let fData = {
            amount: betAmount,
            wallet: wallet?.user_combined_wallet,
            type: betData?.bet_type,
            min: betData?.min,
            max: betData?.max
        }

        let res = Helpers.betValidation(fData);
        if (!res?.status) {
            toast = {
                type: 'error',
                title: 'Validation Error',
                message: res?.message
            }
            // setIsBetAllow(false);
            // setMessage(res?.message);
            setLoading(false);
            dispatch(showToast(toast));
            return;
        }

        let formData = {
            ...betData,
            ['actual_amount']: betAmount,
            ['bet_amount']: betProfitLoss,
            ['payout_amount']: Number(betAmount) + Number(betProfitLoss),
        }


        //console.log(formData); return
        AuthService.placeBetCricket(formData)
            .then(
                (response) => {
                    // console.log(response);
                    if (response.status === 200) {
                        toast = {
                            type: 'success',
                            title: 'Success',
                            message: 'Bet Placed Successfully'
                        }
                        dispatch(fetchWallet());
                        dispatch(showToast(toast));
                        // setTimeout(() => {
                        //     navigate(0);
                        // }, 2000);
                        props.setIsBetPlaced(true);

                    } else {
                        setMessage(response?.message);
                    }
                }
            ).catch((error) => {
                const message = error?.response?.data?.error_description;
                setMessage(message);
                toast = {
                    type: 'error',
                    title: 'Error',
                    message: message
                }
                dispatch(showToast(toast));
                if (error?.response?.data?.status === 401) {
                    localStorage.removeItem("w_token");
                    navigate('/login');
                }
            }).finally(() => {
                setLoading(false);
            });
    }
    return (
        <>

            <div className="calculatorMain calculatorModal">

                <div className="profit" /* style={{marginBottom:`${betData?.bet_type === "odds" ? "70px" : "95px"}`}} */>
                    <h6 style={{ marginBottom: 6 }}><span style={{ fontWeight: 400 }}>Total Bet </span>₹ {Number(betData?.selection_type === 'lay' ? betProfitLoss : betAmount)} </h6>
                    <h6 className="m-0"> <span style={{ fontWeight: 400 }}>Total Payout </span>₹ {(Number(betAmount) + Number(betProfitLoss)).toFixed(2)}</h6>
                    {/* {betData?.bet_type !== 'odds' &&  */}
                    <h6 style={{ background: 'none' }} className="m-0 oddsValue"><span style={{ fontWeight: 400 }}>Odds </span>{betData?.price}</h6>
                    {/* } */}
                </div>
                <div className="d-flex justify-content-between">
                    <div style={{ width: '100%' }}>
                        <div className="d-flex addMinus">
                            <button style={{ background: 'none' }}>₹</button>
                            <input type="text" name="price" placeholder="0" value={betAmount || ''} onChange={(e) => onChangeAmount(e)} maxLength={10} autoComplete="off" />
                        </div>
                    </div>

                </div>
                <div className="sugestionAut calculator-my mb-0">
                    <button onClick={event => handleAmountAdd(event, 100)}><span>+100</span></button>
                    <button onClick={event => handleAmountAdd(event, 500)}><span>+500</span></button>
                    <button onClick={event => handleAmountAdd(event, 1000)}><span>+1000</span></button>
                    <button onClick={event => handleAmountAdd(event, 2500)}><span>+2500</span></button>
                    <button onClick={event => handleAmountAdd(event, 5000)}><span>+5000</span></button>
                    <button onClick={event => handleAmountAdd(event, 10000)}><span>+10000</span></button>
                    <button onClick={event => handleAmountAdd(event, 25000)}><span>+25000</span></button>
                    <button onClick={event => handleAmountAdd(event, 100000)}><span>+100000</span></button>
                </div>
                <div className="maxiMin">
                    <button onClick={() => handleStakeClick(500000)}><span>Max Stake</span></button>
                    <button onClick={() => handleStakeClick(100)}><span>Min Stake</span></button>
                    <button className="cal-clear" onClick={handleClearAmount}><span>Clear</span></button>
                </div>
                <span className="text-center d-block text-danger" style={{ fontSize: 10 }}>{message}</span>

                <div className="cancelBtn">
                    {/* <button className="place-bet-button" onClick={isBetAllow ? handlePlaceBet : undefined} disabled={!isBetAllow || loading}> */}
                    <button className="place-bet-button" onClick={handlePlaceBet} disabled={loading}>
                        {loading ?
                            <>
                                <span className="spinner-border spinner-border-sm me-1" role="status"></span>Please wait...
                            </>
                            :
                            <>Place Bet</>
                        }

                    </button>

                </div>
            </div>

        </>
    )
}
export default CalculatorModel;